import React from 'react';

import styles from 'jbc-front/components/Form.scss';

const RequiredLabel = () => <span className={styles.required}>必須</span>;

export default RequiredLabel;
